import axios from 'axios'
import config from '../config'
import Vue from 'vue'

export default {
  request (method, uri, data = null, isAuth = false) {
    if (!method) {
      console.error('API function call requires method argument')
      return
    }

    if (!uri) {
      console.error('API function call requires uri argument')
      return
    }
    var url = config.serverURI + uri
    if (isAuth) {
      return axios({ method: method, url: url, data: data })
    } else {
      // return axios({ method: method, url: url, data: data, headers: { Authorization: 'Bearer ' + Vue.auth.getToken() } })
      return axios({
        method: method,
        url: url,
        data: data,
        headers: {
          Authorization: 'Bearer ' + Vue.auth.getToken() }
      })
    }
  },
  httpRequest(method, uri) {
    return axios({ method: method, url: uri, responseType: 'stream' })
  },
  httpRequestGoogleAuth(method, uri) {
    return axios({ method: method, url: uri, responseType: 'stream' })
  },
  httpRequestCore(conf) {
    return axios(conf)
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js